module.exports = __webpack_public_path__ + "img/Cancel.85a3ed7a.svg";